module.exports = __webpack_public_path__ + "img/printer.d0713377.svg";